import { render, staticRenderFns } from "./card-media-slider-03.vue?vue&type=template&id=8966e9da&scoped=true&"
import script from "./card-media-slider-03.vue?vue&type=script&lang=js&"
export * from "./card-media-slider-03.vue?vue&type=script&lang=js&"
import style0 from "./card-media-slider-03.vue?vue&type=style&index=0&id=8966e9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8966e9da",
  null
  
)

export default component.exports